import AccessDenied from "src/shared/container/access-denied"
import { usePermission } from "src/shared/hooks/usePermission"

// An array means ANY-OF: the route opens with at least one of the permissions
// (mirrors the backend RequiredPermission decorator).
const PermissionRoute = ({ children, permission }: { permission: string | string[]; children: ReactNode }) => {
  const { hasPermission } = usePermission()
  const anyOf = Array.isArray(permission) ? permission : [permission]
  return anyOf.some((p) => hasPermission(p)) ? children : <AccessDenied />
}

export default PermissionRoute
